/* global angular */
( function () {
	'use strict';
	function Rubric ( coreservice, collectionService, templateservice, deepLoadingStatusService, TOOLTIP_MESSAGES, $modal, apiService ) {
		var self   = this;

		self.title = 'Rubric';

		function getSafeLength () {
			var safeModel   = self.model || {};
			var safeAnswer  = safeModel.answerOptions || '';

			return safeAnswer.length;
		}

		function setGridSize () {
			var safeDivisor = getSafeLength() || 1;

			self.gridSize   = parseInt( 12 / safeDivisor );
		}

		function assignDefaultValue ( option ) {
			return ( option || {} ).value || 0;
		}

		function init () {
			( ( self.model || {} ).answerOptions || [] ).forEach( function ( option ) {
				option.value = assignDefaultValue( option );
			} );
		}

		function activate () {
			deepLoadingStatusService.incrementByArray( self.model, 'answerOptions', 'rubric-options' );
			deepLoadingStatusService.decrementLoading( null, 'indicator' );

			init();
			setGridSize();
		}

		function setStandardDescription ( data, length ) {
			data.description = 'Description ' + length;
		}

		function bindStandardEntry ( model ) {
			var data         = model || {};
			var optionLength = getSafeLength() + 1;

			data.optionText  = 'Title ' + optionLength;

			( !self.disableDescription && setStandardDescription || angular.noop )( data, optionLength );

			data.id = apiService.generateUUID();
			return data;
		}

		function addStandardHandler () {
			collectionService.addModel( self.model.answerOptions, bindStandardEntry() );
			setGridSize();
		}

		function removeStandardHandler ( standard ) {
			collectionService.removeModel( self.model.answerOptions, standard );
			setGridSize();
		}

		function unselectStandardHandler ( standard ) {
			standard.selected = false;
			self.model.score  = 0;
		}

		function selectStandardHandler ( standard, onObservation ) {
			// disable click in table
			if ( ( !standard.selected && self.flag ) || self.readOnly || self.model.notApplicable ) {
				return;
			}

			var selected = standard.selected;

			self.model.answerOptions.map( unselectStandardHandler );

			if ( onObservation && !selected && !self.readOnly ) {
				standard.selected = onObservation;
				self.model.score  = standard.value;
			}
		}

		function checkOptionsLengthHandler ( num ) {
			return getSafeLength() < num;
		}

		function digitsOnly ( option, oldValue ) {
			if ( angular.isUndefined( option.tempValue ) ) {
				option.tempValue = oldValue;
			} else {
				option.value = 0;
			}

			option.tempValue = Number( Number( option.tempValue ).toFixed( 2 ) );

			option.value = option.tempValue;
		}

		function getSiblingScore ( index ) {
			if ( index ) {
				return self.model.answerOptions[ index - 1 ].tempValue || 0;
			}
			return 0;
		}

		function setValue ( model, index ) {
			if ( !self.useRange ) {
				model.tempValue = model.value;
			} else {
				var siblingScore = getSiblingScore( index );

				model.tempValue = model.value || ( siblingScore + 1 );

				if ( siblingScore > model.tempValue ) {
					model.tempValue = siblingScore + 1;
				}
			}

			model.tempValue = Number( Number( model.tempValue ).toFixed( 2 ) );

			model.value = model.tempValue;
		}

		function changeId ( option ) {
			if ( !self.inModal ) {
				var modelData = {
					'id'        : option.id,
					'level'     : 'option',
					'model'     : self.model,
					'subOption' : null
				};

				if ( !option.id ) {
					modelData.model = self.groupModel;
				}

				templateservice.changeId( modelData );
			}
		}

		function openConfirmationModal ( standard ) {
			$modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'type' : function () {
						return 'Standard';
					}
				}
			} ).result.then( function () {
				self.removeStandardHandler( standard );
			} );
		}

		self.setValue              = setValue;
		self.digitsOnly            = digitsOnly;
		self.getSiblingScore       = getSiblingScore;
		self.addStandardHandler    = addStandardHandler;
		self.removeStandardHandler = removeStandardHandler;
		self.selectStandardHandler = selectStandardHandler;
		self.checkOptionsLength    = checkOptionsLengthHandler;
		self.decrementLoading      = deepLoadingStatusService.decrementLoading;
		self.changeId              = changeId;
		self.tooltip               = TOOLTIP_MESSAGES;
		self.openConfirmationModal = openConfirmationModal;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'Rubric', Rubric );

	Rubric.$inject = [ 'coreservice', 'collectionService', 'templateservice', 'deepLoadingStatusService', 'TOOLTIP_MESSAGES', '$modal', 'apiService' ];
} )( );
